import { CATEGORY_STATISTICS } from '../config/constants';

const updatePostHogConsentMode = (categories) => {
    if (window.posthog === undefined) {
        return;
    }

    if (categories.includes(CATEGORY_STATISTICS)) {
        return;
    }

    window.posthog.reset(true);
    window.posthog.opt_out_capturing();
};

export default updatePostHogConsentMode;
